/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since  2017.5.20
 * todo  用canvas完成重绘
 */
let {
  Layer,
  Tooltip,
  setOptions,
  DivOverlay,
  DomUtil
} = L;
let {
  requestAnimFrame
} = L.Util;
/**
 * todo 修整
 */
let TooltipCanvas = L.Canvas.extend({
  /**
   * 
   */
  getEvents() {
    var events = L.Renderer.prototype.getEvents.call(this);
    events.viewprereset = this._onViewPreReset;
    events.zoomstart = this._onZoomStart;
    return events;
  },
  /**
   * 
   */
  _onZoomStart() {
    this._update();
  },
  /**
   * 
   * @param {*} tooltip 
   */
  _updateTooltip(tooltip) {
    if (tooltip.isOpen() === false) {
      return;
    }
    let that = this;

    let {
      _ctx: ctx
    } = that;
    let p = that._map.latLngToLayerPoint(tooltip._latlng);
    let {
      options,
      _source: marker
    } = tooltip;
    let {
      offset,
      direction
    } = options;
    let [offsetX, offsetY] = offset;
    let {
      clientWidth: width,
      clientHeight: height
    } = tooltip._container;
    let tw = 6;
    if (marker && marker.options.offset) {
      let [dx, dy] = marker.options.offset;
      p.x += dx;
      p.y += dy;
    }
    let {
      x,
      y
    } = p;
    // 加大三角缺口
    if ((direction === 'top' || direction === 'bottom') && Math.abs(offsetX / offsetY) > 1 && Math.abs(offsetX / offsetY) < 10 && (Math.abs(offsetX) > 5 || Math.abs(offsetY) > 5)) {
      tw += Math.floor(Math.abs(offsetX / offsetY)) * 3;
    }

    // draw Text
    ctx.beginPath();
    ctx.lineWidth = options.weight || 1;
    ctx.strokeStyle = options.color || '#fff';
    ctx.fillStyle = options.fillColor || '#fff';
    ctx.moveTo(x, y);
    //
    x += offsetX;
    y += offsetY;
    //
    let lineTo = (x, y) => {
      ctx.lineTo(x, y);
    }
    let padding = 6;
    if (options.border > 1) {
      let len = (options.border - 1) * 2;
      width += len;
      height += len;
      padding += options.border;
    }
    //
    switch (direction) {
      case 'left':
        x -= padding;
        lineTo(x, y - tw);
        lineTo(x, y - height / 2);
        lineTo(x - width, y - height / 2);
        lineTo(x - width, y + height / 2);
        lineTo(x, y + height / 2);
        lineTo(x, y + tw);
        break;
      case 'right':
        x += padding;
        lineTo(x, y - tw);
        lineTo(x, y - height / 2);
        lineTo(x + width, y - height / 2);
        lineTo(x + width, y + height / 2);
        lineTo(x, y + height / 2);
        lineTo(x, y + tw);
        break;
      case 'bottom':
        y += padding;
        lineTo(x - tw, y);
        lineTo(x - width / 2, y);
        lineTo(x - width / 2, y + height);
        lineTo(x + width / 2, y + height);
        lineTo(x + width / 2, y);
        lineTo(x + tw, y);
        break;
      case 'top':
      default:
        y -= padding; //.leaflet-tooltip-top { margin-top: -6px;}
        lineTo(x - tw, y);
        lineTo(x - width / 2, y);
        lineTo(x - width / 2, y - height);
        lineTo(x + width / 2, y - height);
        lineTo(x + width / 2, y);
        lineTo(x + tw, y);
        break;
    }
    ctx.lineTo(p.x, p.y);
    ctx.fill();
    ctx.stroke();
  }
})

//
let {
  _initLayout,
  onRemove,
  _setPosition
} = Tooltip.prototype;
let tooltipRenderer;
Tooltip.include({
  /**
   * @override  点击-不关闭
   */
  getEvents() {
    let events = DivOverlay.prototype.getEvents.call(this);
    if (this.options.closeOnClick) {
      events.preclick = this._close;
    }
    // if (this.options.keepInView) {
    //     events.moveend = this._adjustPan;
    // } 
    return events
  },
  /**
   * @override
   */
  _setPosition: function (pos) {
    let {
      offset
    } = this._source.options
    offset && (pos = pos.add(offset))
    _setPosition.call(this, pos)
  },
  /**
   * @override
   */
  _initLayout: function () {
    let {
      options
    } = this;
    _initLayout.call(this); // 初始化
    let {
      offset,
      draggable,
      width,
      style
    } = options;
    let [offsetX, offsetY] = offset;
    let {
      _container: container
    } = this;
    style && T(container).setStyle(style)
    if (draggable) {
      let {
        options,
        _source: marker
      } = this;
      if (marker) {
        // 临时处理，待删除，重新设计
        marker.on('drag', e => {
          marker.closeTooltip();
          marker.openTooltip();
        })
      }
      // container.contentEditable = true;
      container.style.pointerEvents = 'auto';
      container.style.outline = '';
      let action = T(container).draggable();
      action.on('dragstart', e => {
        this._map.dragging.disable();
      }).on('drag', e => {
        let {
          clientWidth: width,
          clientHeight: height
        } = container;
        let mx = width / 2 + 6;
        let my = height / 2 + 6;
        // let { removeClass, addClass } = L.DomUtil;

        let {
          offset
        } = options;

        // 改变offset，不能在原对象上直接改变，因为可能会共用同一个offset来生成Tooltip;
        offset = options.offset = [offset[0] + e.offsetX, offset[1] + e.offsetY];
        let [x, y] = offset;
        let {
          direction
        } = options;
        let from = direction;
        switch (from) {
          case 'top':
            y -= my;
            break;
          case 'bottom':
            y += my;
            break;
          case 'right':
            x += mx;
            break;
          case 'left':
            x -= mx;
            break;
        }
        // let [markerOffsetX, markerOffsetY] = marker.options.offset || [0, 0];
        if (y - Math.abs(x) >= 0) {
          direction = 'bottom';
          y -= my;
        } else if (x - Math.abs(y) >= 0) {
          direction = 'right';
          x -= mx;
        } else if ((-x) - Math.abs(y) >= 0) {
          direction = 'left';
          x += mx;
        } else {
          direction = 'top';
          y += my;
        }
        if (from !== direction) {
          options.offset = [x, y];
          options.direction = direction;
          this._updatePosition();
        }
        //
        requestAnimFrame(tooltipRenderer._update, tooltipRenderer);
        requestAnimFrame(tooltipRenderer._redraw, tooltipRenderer);
      }).on('dragstop', e => {
        this._map.dragging.enable();
      })
    }
    // white-space:pre-line;width:80px;
    if (width > 0) {
      let {
        style
      } = container;
      style.wordBreak = 'break-all';
      style.wordWrap = 'break-word';
      style.whiteSpace = 'pre-wrap';
      style.width = width + 'px';
    }
    if (this._map && (draggable || (Math.abs(offsetX) > 5 || Math.abs(offsetY) > 5) && !options.pin)) {
      T(container).addClass('lk-leaflet-tooltip')
      if (!this._map.getPane('lk_tooltip_pane')) {
        this._map.createPane('lk_tooltip_pane')
        tooltipRenderer = new TooltipCanvas({
          pane: 'lk_tooltip_pane',
          style: {
            pointerEvents: 'none', // ie11+
            zIndex: 399 //
          }
        }).addTo(this._map);
      }
      let renderer = tooltipRenderer;
      renderer._initPath(this);
      renderer._addPath(this);
    }
  },
  /**
   * @override
   */
  _reset() {

  },
  /**
   * @override
   */
  _update() {

  },
  /**
   * @override
   */
  _project() {

  },
  /**
   * 
   * @param {*} map 
   */
  onRemove(map) {
    onRemove.call(this, map);
    if (tooltipRenderer) {
      requestAnimFrame(tooltipRenderer._update, tooltipRenderer);
      requestAnimFrame(tooltipRenderer._redraw, tooltipRenderer)
    }
  },
  /**
   * 
   */
  update() {
    DivOverlay.prototype.update.call(this);
    if (tooltipRenderer) {
      requestAnimFrame(tooltipRenderer._update, tooltipRenderer);
      requestAnimFrame(tooltipRenderer._redraw, tooltipRenderer)
    }
  },
  /**
   * 
   */
  _updatePath() {
    let renderer = tooltipRenderer
    renderer._updateTooltip(this);
  }

})


/**
 * minZoom闭maxZoom开
 */
Layer.include({
  /**
   * @override
   * @param {*} hide 
   */
  hideTooltip: function (hide) {
    let that = this;
    that._hideTooltip = hide;
    if (hide) {
      that.closeTooltip();
    } else {
      that.openTooltip();
    }
  },
  /**
   * @override
   * @param {*} content 
   * @param {*} options 
   */
  bindTooltip: function (content, options) {
    let that = this;

    let {
      _tooltip,
      _map
    } = that;
    if (content instanceof Tooltip) {
      setOptions(content, options);
      that._tooltip = _tooltip = content;
      (content)._source = that;
    } else {
      if (!_tooltip || options) {

        if (options.mode === 'canvas') {
          options = T.assign({}, options, {
            text: content
          })
          that._tooltip = _tooltip = new L.CanvasTooltip(options, that); //导致第一次渲染text,text人不完善，第一次如果是`{name}`，之后是`杭州\n dadadafadscf`会出现渲染问题
        } else {
          that._tooltip = _tooltip = new Tooltip(options, that);
          _tooltip.setContent(content);
        }
      }

    }
    that._initTooltipInteractions();
    options = _tooltip.options;
    let {
      zoom,
      minZoom,
      permanent
    } = options;
    minZoom = options.zoom = options.minZoom = minZoom || zoom;
    if (_map && _map.hasLayer(that)) {
      if (minZoom) {
        minZoom <= _map._zoom && _map.getBounds().contains(that._latlng || that._latlngs[0]) && !that._hideTooltip && that.openTooltip();
      } else if (permanent) {
        !that._hideTooltip && that.openTooltip();
      }
    } else {
      that.on('add', e => {
        let {
          _map
        } = that;
        if (minZoom) {
          let latlng = that._latlng || that._latlngs[0];
          minZoom <= _map._zoom && _map.getBounds().contains(latlng) && !that._hideTooltip && that.openTooltip();
        }
      })
    }
    return that;
  },
  /**
   * @override
   * @param {*} e 
   */
  closeTooltip: function (e) {
    let {
      _tooltip,
      _map
    } = this;
    if (_tooltip) {
      let {
        options
      } = _tooltip;
      if (e && e.type !== 'remove') {
        if (e.target && _map && options.zoom <= _map._zoom) {
          return;
        }
      }
      _tooltip._close();
      if (options.interactive && _tooltip._container) {
        DomUtil.removeClass(_tooltip._container, 'leaflet-clickable');
        this.removeInteractiveTarget(_tooltip._container);
      }
    }
    return this;
  },
  /**
   * @override
   * @param {*} e 
   */
  _openTooltip: function (e) {
    let that = this;
    let layer = e.layer || e.target;
    let {
      _tooltip,
      _map
    } = that;
    if (!_tooltip || !_map || _tooltip.isOpen()) {
      return;
    }!that._hideTooltip && that.openTooltip(layer, _tooltip.options.sticky ? e.latlng : undefined);
  }
});



// WEBPACK FOOTER //
// ./src/polyfill/Tooltip.js